import Vue from "vue";
import axios from "axios";
import VueCookies from "vue-cookies";
// import router from "@/router/index";
import { API_V4 } from "@/services/config/auth-axios";
import i18n from "@/plugins/i18n";

Vue.use(VueCookies);

// ساخت نمونه axios برای بازار
const $marketAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_MARKET,
  headers: {
    "Content-Type": "multipart/form-data",
    "Accept-Language": VueCookies.get("lang"),
    "client-lang": VueCookies.get("lang") || null
  }
});

// متغیرها برای صف ریکوئست‌ها هنگام رفرش توکن
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// اینترسپتور درخواست
$marketAxios.interceptors.request.use(
  config => {
    const token = Vue.$cookies.get("accessToken");
    const uuid = Vue.$cookies.get("CA_ID");
    const xAuthToken = localStorage.getItem("TOKEN");

    if (xAuthToken) {
      config.headers["x-auth-token"] = xAuthToken;
    }
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers["Client-Lang"] = i18n.locale;

    if (uuid) {
      config.headers["account-id"] = uuid;
    }
    return config;
  },
  error => Promise.reject(error)
);

// اینترسپتور پاسخ
$marketAxios.interceptors.response.use(
  async response => {
    const xAuthToken = response.headers["x-auth-token"];
    if (xAuthToken) {
      localStorage.setItem("TOKEN", xAuthToken);
    }
    if (response.data.code === 403) {
      await localStorage.setItem("isAuth", "false");
      await localStorage.removeItem("accessToken");
      await Vue.$cookies.remove("accessToken");
      await Vue.$cookies.remove("accessToken", null, ".ernyka.com");
      await Vue.$cookies.remove("accessToken", null, ".excoino.com");
      window.location = `${process.env.VUE_APP_BASE_URL}/auth/login`;
    }

    if (response.data.code === 401) {
      // توکن منقضی شده و نیاز به رفرش دارد
      const originalRequest = response.config;

      if (!originalRequest._retry) {
        originalRequest._retry = true;

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then(token => {
              originalRequest.headers["Authorization"] = "Bearer " + token;
              return $marketAxios(originalRequest);
            })
            .catch(err => Promise.reject(err));
        }

        isRefreshing = true;
        try {
          const refreshToken = Vue.$cookies.get("refreshToken");

          const res = await API_V4.post(
            `${process.env.VUE_APP_BASE_URL_V4}/users/token/get-by-refresh`,
            { refresh_token: refreshToken }
          );

          const newToken = res.data.data.token;
          const newRefreshToken = res.data.data.refresh_token;

          Vue.$cookies.set("accessToken", newToken);
          Vue.$cookies.set("refreshToken", newRefreshToken);
          localStorage.setItem("accessToken", newToken);
          localStorage.setItem("refreshToken", newRefreshToken);

          processQueue(null, newToken);

          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          return $marketAxios(originalRequest);
        } catch (err) {
          processQueue(err, null);

          await localStorage.setItem("isAuth", "false");
          await localStorage.removeItem("accessToken");
          await Vue.$cookies.remove("accessToken");
          await Vue.$cookies.remove("CA_ID");
          await Vue.$cookies.remove("isLegal");
          this.$cookies.set("showAlert", "false");
          await Vue.$cookies.remove("accessToken", null, ".ernyka.com");
          await Vue.$cookies.remove("accessToken", null, ".excoino.com");
          window.location = `${process.env.VUE_APP_BASE_URL}/auth/login`;

          return Promise.reject(err);
        } finally {
          isRefreshing = false;
        }
      }

      // اگر _retry=true بود یعنی قبلاً رفرش کرده ولی باز هم 401 گرفته
      await localStorage.setItem("isAuth", "false");
      await localStorage.removeItem("accessToken");
      await Vue.$cookies.remove("accessToken");
      await Vue.$cookies.remove("accessToken", null, ".ernyka.com");
      await Vue.$cookies.remove("accessToken", null, ".excoino.com");
      window.location = `${process.env.VUE_APP_BASE_URL}/auth/login`;
    }

    if (response.data.code >= 500 && response.data.code !== 40901) {
      //40901 => dis claimer order
      Vue.$toast.error(response.data.message || "خطای داخلی سرور");
      // router.push({
      //   name: "error-page",
      //   params: { errorBody: response }
      // });
    }

    return response;
  },
  error => {
    if (
      error &&
      error.response &&
      error.response.config &&
      error.response.config.method !== "get"
    ) {
      Vue.$toast.clear();
      Vue.$toast.updateDefaults({
        rtl: localStorage.getItem("direction") === "rtl"
      });

      if (error.response.data?.errors) {
        Object.values(error.response.data.errors).forEach(value => {
          Vue.$toast.error(value[0]);
        });
      } else {
        Vue.$toast.error(
          error.response.data?.message || "خطا در ارتباط با سرور"
        );
      }
    }

    return Promise.reject(error.response);
  }
);

export default $marketAxios;
